import { render, staticRenderFns } from "./CreateRow.vue?vue&type=template&id=667580a6"
import script from "./CreateRow.vue?vue&type=script&lang=js"
export * from "./CreateRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports